import { render, staticRenderFns } from "./Substitution.vue?vue&type=template&id=706f43be&scoped=true&lang=pug&"
import script from "./Substitution.vue?vue&type=script&lang=ts&"
export * from "./Substitution.vue?vue&type=script&lang=ts&"
import style0 from "./Substitution.vue?vue&type=style&index=0&id=706f43be&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706f43be",
  null
  
)

export default component.exports